module.exports = __webpack_public_path__ + "static/media/logoFooter.272b899f.png";